var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPermissionupdated(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Permission_updated",
    "data-name": "Permission updated",
    transform: "translate(-1043.518 -1430.32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38833",
    "data-name": "Path 38833",
    d: "M25.4,0A25.4,25.4,0,1,1,0,25.4,25.4,25.4,0,0,1,25.4,0",
    transform: "translate(1044.122 1430.924)",
    fill: "#56aa1c"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_31696",
    "data-name": "Rectangle 31696",
    width: 52,
    height: 52,
    transform: "translate(1043.518 1430.32)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38151",
    "data-name": "Path 38151",
    d: "M0,13.788v9.74c0,5.379,4.851,9.741,10.835,9.741S21.67,28.907,21.67,23.528v-9.74Zm11.535,8.539v3.509h-1.4V22.322a1.928,1.928,0,1,1,1.4,0m7.862-9.7h-2V8.561a6.562,6.562,0,0,0-13.124,0V12.62h-2V8.561a8.562,8.562,0,0,1,17.124,0Z",
    transform: "translate(1058.683 1438.438)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4838",
    "data-name": "Rectangle 4838",
    width: 21.67,
    height: 33.269,
    transform: "translate(1058.683 1438.438)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionupdated);
export default __webpack_public_path__ + "static/media/Permission updated.5019dfd73faa6d0a04ab8a80210a686d.svg";
export { ForwardRef as ReactComponent };